__turbopack_context__.v({
  "heading": "GalleryDaySection-module__Y89r5W__heading",
  "section": "GalleryDaySection-module__Y89r5W__section",
});
